import React from 'react';
import { PublicSetInfo } from 'store/services/sets/publicSetsApi';
import { buildSetDescription } from './setDescriptionTemplates';
import './SetDescription.css';

interface SetDescriptionProps {
  set: PublicSetInfo;
  totalCards: number;
}

export const SetDescription: React.FC<SetDescriptionProps> = ({ set, totalCards }) => {
  const text = buildSetDescription({
    name: set.name,
    code: set.code,
    releasedAt: set.releasedAt,
    setType: set.setType,
    cardCount: totalCards,
  });

  return (
    <section className="set-description" aria-label="About this set">
      <p className="set-description-text">{text}</p>
    </section>
  );
};
